import TileType from '~/constants/TileType';
import type { AppliedFilters, ConditionalTile, DeviceData } from '~/contracts';

export type OwnProps = {
  device: Partial<DeviceData>;
  filters: Partial<AppliedFilters>;
};

export default function getGreatDealTile({
  device,
  filters
}: OwnProps): ConditionalTile {
  const inactive =
    filters?.tagIds?.some(v => [104, '104'].includes(v)) ?? false;
  const index = device.width == null || device.width < 1800 ? 23 : 24;

  return { active: !inactive, index, tileType: TileType.GreatDeal };
}
